// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const numberIcon = "MenuButton__numberIcon__1AEeW";
export const hamburger = "MenuButton__hamburger__Brq-Y";
export const open = "MenuButton__open__syNTy";
export const icon = "MenuButton__icon__HCi6O";
export const iconHamburger = "MenuButton__iconHamburger__WFTnp";
export const iconCross = "MenuButton__iconCross__gvvv5";